import { render, staticRenderFns } from "./SpinnersComponent.vue?vue&type=template&id=7e5365f1"
var script = {}
import style0 from "./SpinnersComponent.vue?vue&type=style&index=0&id=7e5365f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports